module.exports = __webpack_public_path__ + "img/CN.f4c875da.svg";